import React from "react";

export const LazyFooter = React.lazy(() => import("./footer/Footer"));
export const LazyCustomerFeedback = React.lazy(() => import("./reviews/CustomerFeedback"));
export const LazyPopularMenu = React.lazy(() => import("./menu/PopularMenu"));
export const LazyAboutPage = React.lazy(() => import("./about/AboutPage"));
export const LazyCatergoryCard = React.lazy(() => import("../minis/CategoryCards"));
export const LazyContactPage = React.lazy(() => import("./contact/ContactPage"));
export const LazyMenuPage = React.lazy(() => import("./menu/MenuPage"));
